exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ResizeAreaVcDemo h4[data-v-017c1351]{color:#066}.ResizeAreaVcDemo .demoItem[data-v-017c1351]{padding:10px 0;font-size:18px;border-bottom:1px dotted #999}.ResizeAreaVcDemo .area-icon[data-v-017c1351]{display:inline-block;height:50px;width:130px;text-align:center;line-height:50px;border:1px solid #ccc;background-color:#0c9;margin:10px;font-size:18px;color:#fff}", ""]);

// exports
